export default function themeColor(color, fallback, theme) {
  return (
    theme.colors[color]?.color || theme.colors[fallback]?.color || 'transparent'
  )
}
